export default {
    async createShortenLinks(link) {
        try {
            const request = await fetch(`https://api.shrtco.de/v2/shorten?url=${link}`)
            const response = await request.json()
            if (response.ok === false)
                throw response.error

            return { isSuccessful: true, shortenLink: response.result.full_short_link }
        } catch (e) {
            return { isSuccessful: false }
        }
    }
}